"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9817],{

/***/ 19817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionSideContentWithMedia": function() { return /* binding */ SectionSideContentWithMedia; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);



const SectionSideContentContainer = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    "@lg": {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 64,
        paddingInline: 32
    }
});
const SectionSideContentTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("h2", {
    marginBottom: 56,
    projectFont: "heading04",
    color: "$white",
    paddingInline: 32,
    "@lg": {
        paddingInline: 0,
        marginBottom: 0
    }
});
const ContentList = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    gridAutoFlow: "column",
    gap: "$20",
    gridAutoColumns: "75vw",
    paddingInline: 32,
    scrollPaddingInline: 32,
    overflowX: "auto",
    overflowY: "hidden",
    scrollSnapType: "x mandatory",
    "&::-webkit-scrollbar": {
        display: "none"
    },
    "@lg": {
        display: "flex",
        flexDirection: "column",
        gap: 72,
        width: "auto",
        overflow: "visible",
        scrollSnapType: "none",
        paddingInline: 0,
        scrollPaddingInline: 0
    }
});
const ContentItem = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    scrollSnapAlign: "start",
    "@lg": {
        flexDirection: "row",
        alignItems: "flex-start"
    }
});
const MediaContainerMobile = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    borderRadius: 6,
    overflow: "hidden",
    width: "100%",
    "@lg": {
        display: "none"
    }
});
const MediaContainerDesktop = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    borderRadius: 6,
    overflow: "hidden",
    width: "100%",
    maxWidth: 120,
    display: "none",
    "@lg": {
        display: "block"
    }
});
const ContentWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    width: "100%"
});
const CustomPortableTextWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    fontFamily: "var(--font-suisse-intl-regular), sans-serif",
    fontWeight: 400,
    fontSize: 20,
    lineHeight: "130%",
    color: "$white"
});
function SectionSideContentWithMedia(param) {
    let { title , content , spacing , topBorder  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .SectionWrapper */ .Uq, {
        type: spacing || "DEFAULT",
        topBorder: topBorder,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SectionSideContentContainer, {
            children: [
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionSideContentTitle, {
                    children: title
                }),
                content && content.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentList, {
                    children: content.map((item, index)=>{
                        var _item_media;
                        const itemKey = "_key" in item && typeof item._key === "string" ? item._key : "item-".concat(index);
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContentItem, {
                            children: [
                                ((_item_media = item.media) === null || _item_media === void 0 ? void 0 : _item_media.mediaPayload) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MediaContainerDesktop, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
                                                ...item.media,
                                                layout: "responsive",
                                                hardcropRatio: "square",
                                                sizes: "(max-width: 768px) 75vw, 120px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MediaContainerMobile, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
                                                ...item.media,
                                                layout: "responsive",
                                                hardcropRatio: "landscape4",
                                                sizes: "(max-width: 768px) 75vw, 120px"
                                            })
                                        })
                                    ]
                                }),
                                item.localeEditorialRichText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentWrapper, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomPortableTextWrapper, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .PortableText */ .YI, {
                                            value: item.localeEditorialRichText,
                                            appearance: "plain",
                                            disableTopBottomMargins: true
                                        })
                                    })
                                })
                            ]
                        }, itemKey);
                    })
                })
            ]
        })
    });
}


/***/ })

}]);